import { render } from "./Label.vue?vue&type=template&id=9c0cc1b0"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Label.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c0cc1b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c0cc1b0', __exports__)) {
    api.reload('9c0cc1b0', __exports__)
  }
  
  module.hot.accept("./Label.vue?vue&type=template&id=9c0cc1b0", () => {
    api.rerender('9c0cc1b0', render)
  })

}


export default __exports__